// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.

import React from "react";
import styles from "./Avatar.module.css";

export const Avatar = ({
  size = 48,
  firstName,
  lastName,
  color = "var(--color-light)",
}) => {
  const initials =
    `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase() || "?";

  const style = {
    width: size,
    height: size,
    border: `1px solid ${color}`,
    fontSize: size * 0.4,
    color,
  };

  return (
    <div
      className={styles.avatar}
      style={style}
      role="img"
      aria-label={`Avatar for ${firstName} ${lastName}`}
    >
      {initials}
    </div>
  );
};
